import React from 'react';
import '../../assets/css/event2607.css';

import { TopButton } from "../../components/TopButton"
import { Link } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import { useGSAP } from '@gsap/react';
import { EVENT_2607_PERIOD, isEventOver, isEventUpcoming } from '../../config/events';

// 피그마 배경 그라데이션(블러 도형) 좌표를 콘텐츠 박스(870x4389) 기준 %로 변환한 값
// -> 콘텐츠가 커지거나(최대 550px) 작아져도(모바일 100%) 같은 비율로 따라감
const BLOBS = [
    { name: 'blob01', left: -124.83, top: 26.59, width: 141.61, height: 28.07 },
    { name: 'blob02', left: 85.86, top: 41.19, width: 171.49, height: 33.99 },
    { name: 'blob03', left: -110.46, top: 78.10, width: 175.18, height: 34.72 },
    { name: 'blob04', left: -116.20, top: -14.74, width: 197.24, height: 39.10 },
    { name: 'blob05', left: -116.20, top: -22.94, width: 197.24, height: 39.10 },
    { name: 'blob06', left: -87.47, top: 33.06, width: 139.65, height: 27.68 },
    { name: 'blob07', left: 21.04, top: -25.52, width: 197.24, height: 39.10 },
    { name: 'blob08', left: -100.23, top: 84.10, width: 172.75, height: 34.24 },
    { name: 'blob09', left: 36.09, top: 79.11, width: 136.55, height: 27.07 },
    { name: 'blob10', left: 28.16, top: 84.10, width: 172.75, height: 34.24 },
];

// 본문 이미지 6장 - 콘텐츠 박스(870x4389) 기준 top/height %
const PHOTOS = [
    { name: 'img01', top: 0, height: 34.34 },
    { name: 'img02', top: 34.34, height: 34.38 },
    { name: 'img03', top: 68.72, height: 4.35 },
    { name: 'img04', top: 73.07, height: 14.35 },
    { name: 'img05', top: 87.42, height: 3.51 },
    { name: 'img06', top: 90.93, height: 9.07 },
];

export default function Event2607() {

    useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `혹서기 캠페인 | 어르신본죽왔어요`;
    },[]);

    const [showExpiredModal, setShowExpiredModal] = useState(() => isEventOver(EVENT_2607_PERIOD));
    const [showUpcomingModal, setShowUpcomingModal] = useState(() => isEventUpcoming(EVENT_2607_PERIOD));

    const container = useRef();

    useGSAP(() => {

    }, { scope: container });

    return (
        <article id='evnet-body' ref={container}>

            <TopButton />

            {(showExpiredModal || showUpcomingModal) && (
                <div className='sum-expired-overlay'>
                    <div className='sum-expired-modal'>
                        <button
                            type='button'
                            className='sum-expired-close'
                            aria-label='닫기'
                            onClick={() => {
                                setShowExpiredModal(false);
                                setShowUpcomingModal(false);
                            }}
                        >
                            ✕
                        </button>
                        <p>{showExpiredModal ? '종료된 이벤트입니다.' : '아직 시작 전인 이벤트입니다.'}</p>
                        <Link to="/">메인으로 이동</Link>
                    </div>
                </div>
            )}

            <section id='sum-wrap'>

                <div id='sum-bg'></div>

                <div id='sum-content'>

                    {BLOBS.map((blob) => (
                        <img
                            key={blob.name}
                            className='sum-blob'
                            style={{ left: `${blob.left}%`, top: `${blob.top}%`, width: `${blob.width}%`, height: `${blob.height}%` }}
                            src={process.env.PUBLIC_URL + `upload/2607/${blob.name}.svg`}
                            alt=""
                        />
                    ))}

                    {PHOTOS.map((photo) => {
                        const img = (
                            <img
                                src={process.env.PUBLIC_URL + `upload/2607/${photo.name}.jpg`}
                                alt={photo.alt || ''}
                            />
                        );
                        return (
                            <div
                                key={photo.name}
                                className='sum-photo'
                                style={{ top: `${photo.top}%`, height: `${photo.height}%` }}
                            >
                                {photo.name === 'img03' && (
                                    <Link to="http://pf.kakao.com/_rdmwd" target='_blank' rel="noopener noreferrer">{img}</Link>
                                )}
                                {photo.name === 'img05' && (
                                    <Link to="https://m.blog.naver.com/bonlove09/224002729099" target='_blank'>{img}</Link>
                                )}
                                {photo.name !== 'img03' && photo.name !== 'img05' && img}
                            </div>
                        );
                    })}
                </div>

            </section>

        </article>

    )

}
